import React from "react";
import Header from "~/components/common/Header";
import { type HeaderProps } from "~/components/common/Header";
import { headerOffset } from "~/components/common/header-metrics";
import { cn } from "~/lib/utils";

interface PageContainerProps {
  children: React.ReactNode;
  showHeader?: boolean;
  headerProps?: HeaderProps;
  className?: string;
}

export default function PageContainer({ children, showHeader = true, headerProps, className }: PageContainerProps) {
  const pad = showHeader ? headerOffset(headerProps?.showAnnouncement).pad : "";

  return (
    <>
      {showHeader && <Header {...headerProps} />}
      <div className={cn(pad, "flex min-h-screen flex-col justify-between bg-[#F8F8F2]", className)}>{children}</div>
    </>
  );
}
